import { useState } from "react";

import {
  ACTIVATE_CONFIRM_LABEL,
  ACTIVATE_MESSAGE,
  ACTIVATE_SUBTITLE,
  ACTIVATE_TITLE,
  DEACTIVATE_CONFIRM_LABEL,
  DEACTIVATE_MESSAGE,
  DEACTIVATE_SUBTITLE,
  DEACTIVATE_TITLE,
} from "./toggle-user-status-dialog.constants";
import type {
  ToggleUserStatusDialogProps,
  ToggleUserStatusDialogViewModel,
} from "./types-toggle-user-status-dialog";
import { buildUserContato } from "../../users.utils";

/**
 * Confirmação da ativação e da inativação (RN04): o modal mostra o impacto da operação (MS001 ao desativar, MS002 ao
 * ativar) e só altera o status depois do Confirmar.
 */
export function useToggleUserStatusDialog({
  user,
  onConfirm,
  onCancel,
}: ToggleUserStatusDialogProps): ToggleUserStatusDialogViewModel {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const desativando = user.status === "ativo";

  return {
    contato: buildUserContato(user, "toggle-user-status"),
    desativando,
    titulo: desativando ? DEACTIVATE_TITLE : ACTIVATE_TITLE,
    subtitulo: desativando ? DEACTIVATE_SUBTITLE : ACTIVATE_SUBTITLE,
    mensagem: desativando ? DEACTIVATE_MESSAGE : ACTIVATE_MESSAGE,
    confirmLabel: desativando ? DEACTIVATE_CONFIRM_LABEL : ACTIVATE_CONFIRM_LABEL,
    isSubmitting,
    confirmar: () => {
      setIsSubmitting(true);
      void onConfirm().finally(() => setIsSubmitting(false));
    },
    cancelar: onCancel,
  };
}
